import React, { useEffect, useRef, useState } from "react";
import caService from "../../api/caService";
import { getRequest } from "../../api/http";
import "./Rewards.scss";
import toastr from "toastr";
import { Modal, Button, Card, Tag, Image, Typography } from "antd";
import level1 from "../../assets/images/level_1.jpg";
import level2 from "../../assets/images/level_2.jpg";
import level3 from "../../assets/images/level_3.jpg";
import level4 from "../../assets/images/level_4.jpg";
import level5 from "../../assets/images/level_5.jpg";
import level6 from "../../assets/images/level_6.jpg";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
const { Title, Paragraph } = Typography;

function Rewards() {
  const scrollRef = useRef(null);
  const [rewards, setRewards] = useState([]);
  const [selectedReward, setSelectedReward] = useState(null);
  const [levels, setLevels] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const checkForScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
    }
  };
  useEffect(() => {
    fetchRewardDetails();
    getLevels();
    const handleResize = () => {
      checkForScrollPosition();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    checkForScrollPosition();
  }, [rewards, levels]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300; // Adjust as needed
      const { scrollLeft, clientWidth, scrollWidth } = scrollRef.current;
      let newScrollLeft = direction === "left"
        ? scrollLeft - scrollAmount
        : scrollLeft + scrollAmount;

      // Ensure the new scroll position is within bounds
      newScrollLeft = Math.max(newScrollLeft, 0);
      newScrollLeft = Math.min(newScrollLeft, scrollWidth - clientWidth);

      scrollRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });

      // Check scroll position after scrolling
      setTimeout(checkForScrollPosition, 100);
    }
  };
  
  const fetchRewardDetails = async () => {
    try {
      const response = await getRequest(caService.getRewardDetails());
      console.log(response, "data");
      setRewards(response.caRewardDtos);
    } catch (e) {
      toastr.error(e.message);
    }
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedReward(null);
  };
  const fetchRewards = async (taskId) => {
    try {
      const response = await getRequest(caService.getRewardById(taskId));
      console.log(response, "data");
      setSelectedReward(response);
      setIsModalVisible(true);
    } catch (e) {
      toastr.error(e.message);
    }
  };
  const handleCardClick = (rewardId) => {
    fetchRewards(rewardId);
  };
  const getLevels = async () => {
    try {
      const response = await getRequest(caService.getLevels());
      console.log(response, "levels");
      setLevels(response);
    } catch (error) {
      toastr.error(error.message);
    }
  };
  const levelImages = {
    LEVEL_ONE:
      "https://as2.ftcdn.net/v2/jpg/03/41/17/99/1000_F_341179954_oECc5A6npAYJD728C4hC0xDLHDaDtzHY.jpg",
    LEVEL_TWO:
      " https://as1.ftcdn.net/v2/jpg/07/22/69/14/1000_F_722691424_QlKUEMT11B0KUHEjvBhCQh1IEIBVgPvW.jpg",
    LEVEL_THREE:
      "https://as2.ftcdn.net/v2/jpg/04/63/54/71/1000_F_463547137_HbQsdRnjuAD0xAPY7LdrSlSCR9Ens42P.jpg",
    LEVEL_FOUR:
      "https://t3.ftcdn.net/jpg/04/68/33/22/240_F_468332291_3qywVRwk9Bm40IgadEJcEmZcwxX6MCVp.jpg",

    // Add more level-specific images here
  };
  
  const levelImage = [level1, level2, level3, level4, level5, level6];
  const assignDonutImages = (rewardCount) => {
    const startIndex = Math.max(levelImage.length - rewardCount, 0);
    return levelImage.slice(startIndex);
  };
  return (
    <div className="rewards">
    <div className="rewards-container" style={{paddingLeft: canScrollLeft ? "40px" : "0px"}}>
    {canScrollLeft && (
          <div className="scroll-button left" onClick={() => scroll("left")}>
            <LeftOutlined />
          </div>
        )}
      <div className="rewards-scroll"  ref={scrollRef}>
        <div className="rewards-header">
          {levels.map((level) => {
            const donutImagesForLevel = assignDonutImages(level.taskCount);

            return (
              <React.Fragment key={level.id}>
                <div className="level-header">
                  <div className="level-icon-container">
                    <img src={level.iconUrl} alt={level.name} />
                  </div>
                </div>
                <div className="reward-main">
                  {rewards.filter((reward) => reward.levelId === level.id).map((reward, index) => (
                    <div
                      key={reward.id}
                      className={`rewards-card`}
                    >
                      <div className={`reward-icon-container  ${
                        reward.status === "REWARD_ISSUED"
                          ? "issued-border"
                          : reward.status === "REWARD_PENDING"
                          ? "pending-border"
                          : "null"
                      }`}>
                        <img
                          src={donutImagesForLevel[index]||"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpnzgqti1rBYn1uoGxxFl31D1z_qlqr3NOmQ&s"}
                          alt={reward.name}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
      {canScrollRight && (
          <div className="scroll-button right" onClick={() => scroll("right")}>
            <RightOutlined />
          </div>
        )}
    </div>
    <div className="rewards-content">
        <h2>Your rewards</h2>
        <div className="rewards-list">
          {rewards.map((reward) => (
            <div
              key={reward.id}
              className={`reward-card ${
                reward.status === "REWARD_PENDING" || reward.status === null
                  ? "expired"
                  : ""
              }`}
              onClick={() => handleCardClick(reward.taskId)}
            >
              <div className="reward-img">
                <img
                  src={
                    reward?.bannerImageUrl ||
                    "https://www.businessmanager.in/wp-content/uploads/2022/05/Rewards-and-Recognition-at-workplaces.jpg"
                  }
                  alt={reward.title}
                />
              </div>
              <div className="reward-details">
                <h3>{reward.rewardName}</h3>
                <p>{reward.rewardDescription}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {selectedReward && (
        <Modal
          className="modal-reward"
          visible={isModalVisible}
          onCancel={handleCancel}
          style={{ borderRadius: "11px" }}
          width={420}
        >
          <div className="reward-modal-content">
            <img
              src={
                selectedReward.bannerImageUrl ||
                levelImages[selectedReward.stage] ||
                "https://www.businessmanager.in/wp-content/uploads/2022/05/Rewards-and-Recognition-at-workplaces.jpg"
              }
              alt={selectedReward.rewardName}
              className="reward-modal-image"
              style={{
                marginBottom: 16,
                borderTopLeftRadius: "12px",
                borderTopRightRadius: "12px",
              }}
            />
            <div className="reward-modal-details">
              <div className="reward-modal-title">
                <div className="icon-image">
                  <Image
                    className="icon-image-reward"
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpnzgqti1rBYn1uoGxxFl31D1z_qlqr3NOmQ&s"
                    preview={false}
                  />
                </div>
                <span className="reward-modal-title-label">
                  {selectedReward.rewardName}
                </span>
              </div>
              <div className="reward-modal-description">
                {selectedReward.rewardDescription}
              </div>
              {selectedReward.rewardCategory === "DONUTS" ? (
                <div className="reward-modal-description">
                  this reward has {selectedReward.donutCount} donuts
                </div>
              ) : selectedReward.rewardCategory === "COUPON_CODE" ? (
                <div className="reward-modal-description">
                  Coupon code:{" "}
                  {selectedReward.couponCode
                    ? selectedReward.couponCode
                    : "Not yet revealed"}
                </div>
              ) : selectedReward.rewardType === "EXTERNAL" ? (
                <div className="reward-modal-description">
                  this is an external reward
                </div>
              ) : null}
              {selectedReward.rewardInsights.length > 1 && (
                <div className="reward-modal-list">
                  <div className="reward-modal-header">Details</div>
                  <ul>
                    {selectedReward?.rewardInsights.map((reward, index) => {
                      <li key={index}>{reward}</li>;
                    })}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default Rewards;
